import { Text } from "@flixbus/honeycomb-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import * as css from "./SearchResultCount.scss";

type Props = { numOfSearchResults: number };

const getMessageId = (count: number) => {
  if (count === 0) return "faq.search.resultCount.zero";
  if (count === 1) return "faq.search.resultCount.one";
  return "faq.search.resultCount.other";
};

const SearchResultCount: React.FC<Props> = ({ numOfSearchResults }) => {
  return (
    <div className={css.resultsWrapper}>
      <Text small extraClasses={css.results}>
        <FormattedMessage
          id={getMessageId(numOfSearchResults)}
          values={{ amount: numOfSearchResults, b: (chunks) => <b>{chunks}</b> }}
        />
      </Text>
    </div>
  );
};

export default SearchResultCount;
